import type { Nullish } from '@/types/nullish';
import { isNullish } from './is-nullish';

export const SYSTEM_FALLBACK = '-';
export const USER_INPUT_FALLBACK = '';

type DisplayValue = string | number | bigint | boolean | Nullish;

const createValueFormatter =
  (fallback: string) =>
  (strings: TemplateStringsArray, ...values: DisplayValue[]): string => {
    if (values.some((value) => isNullish(value) || value === '')) {
      return fallback;
    }

    return strings.reduce(
      (result, string, index) =>
        result + (index ? String(values[index - 1]) : '') + string,
      '',
    );
  };

export const formatSystemValues = createValueFormatter(SYSTEM_FALLBACK);
export const formatUserInputValues = createValueFormatter(USER_INPUT_FALLBACK);

/** Use for displaying system values; missing or empty values fall back to `-`. */
export const fallbackSystemValue = <T>(value: T | Nullish): string | T => {
  if (isNullish(value) || value === '') {
    return SYSTEM_FALLBACK;
  }

  return value;
};

/** Use for user input values; missing values fall back to an empty string. */
export const fallbackUserInputValue = <T>(value: T | Nullish): string | T => {
  if (isNullish(value)) return USER_INPUT_FALLBACK;

  return value;
};
